import { queryOptions } from '@tanstack/react-query';

import { gammaRoleRequestsClient } from './client';
import type { RoleRequestStatus } from './types';

export const GAMMA_ROLE_REQUEST_QUERY_KEYS = {
  list: 'gamma-role-requests',
};

export const _getGammaRoleRequests = (status?: RoleRequestStatus, enabled = true) =>
  queryOptions({
    enabled,
    queryKey: [GAMMA_ROLE_REQUEST_QUERY_KEYS.list, status],
    queryFn: () => gammaRoleRequestsClient.list(status),
  });
